// src/components/RoomLobby.js
import React, { useState, useEffect } from 'react';
import { useGame } from '../contexts/GameContext';
import './RoomLobby.css';

function RoomLobby({ nickname }) {
  const { currentRoom, isInRoom, createRoom, joinRoom, leaveRoom, setReady, connect, wsStatus } = useGame();
  const [roomIdInput, setRoomIdInput] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    // 连接 WebSocket
    if (wsStatus === 'disconnected') {
      connect();
    }
  }, [connect, wsStatus]);

  const handleCreateRoom = () => {
    setIsCreating(true);
    createRoom(nickname);
  };

  const handleJoinRoom = () => {
    if (roomIdInput.trim()) {
      joinRoom(roomIdInput.trim(), nickname);
    }
  };

  const handleLeaveRoom = () => {
    leaveRoom();
    setIsCreating(false);
  };

  const handleToggleReady = () => {
    if (currentRoom) {
      const myPlayer = currentRoom.players?.find(p => p.nickname === nickname);
      setReady(!myPlayer?.is_ready);
    }
  };

  if (wsStatus === 'connecting') {
    return (
      <div className="room-lobby">
        <div className="lobby-card">
          <h2>连接中...</h2>
        </div>
      </div>
    );
  }

  if (wsStatus === 'disconnected' || wsStatus === 'auth_error') {
    return (
      <div className="room-lobby">
        <div className="lobby-card error">
          <h2>连接失败</h2>
          <p>WebSocket 连接已断开，请刷新页面重试</p>
        </div>
      </div>
    );
  }

  if (!isInRoom) {
    return (
      <div className="room-lobby">
        <div className="lobby-card">
          <h1>斋普尔 (Jaipur) 卡牌游戏</h1>
          <p className="welcome-text">欢迎，{nickname}！</p>

          <div className="lobby-actions">
            <div className="action-section">
              <h3>创建新房间</h3>
              <button
                className="btn btn-primary btn-large"
                onClick={handleCreateRoom}
                disabled={isCreating}
              >
                {isCreating ? '创建中...' : '创建房间'}
              </button>
            </div>

            <div className="divider">
              <span>或</span>
            </div>

            <div className="action-section">
              <h3>加入房间</h3>
              <input
                type="text"
                className="room-input"
                placeholder="输入6位房间号"
                value={roomIdInput}
                onChange={(e) => setRoomIdInput(e.target.value)}
                maxLength={6}
              />
              <button
                className="btn btn-secondary btn-large"
                onClick={handleJoinRoom}
                disabled={!roomIdInput.trim()}
              >
                加入房间
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 在房间中
  const myPlayer = currentRoom.players?.find(p => p.nickname === nickname);
  const opponent = currentRoom.players?.find(p => p.nickname !== nickname);
  const allReady = currentRoom.players?.every(p => p.is_ready);

  return (
    <div className="room-lobby">
      <div className="lobby-card">
        <div className="room-header">
          <h2>房间号: {currentRoom.room_id}</h2>
          <button className="btn btn-danger btn-small" onClick={handleLeaveRoom}>
            离开房间
          </button>
        </div>

        <div className="players-container">
          <div className="player-slot">
            <div className={`player-card ${myPlayer?.is_ready ? 'ready' : ''}`}>
              <div className="player-avatar">👤</div>
              <h3>{myPlayer?.nickname || '等待玩家...'}</h3>
              <span className="status-badge">
                {myPlayer?.is_ready ? '已准备' : '未准备'}
              </span>
            </div>
          </div>

          <div className="vs-divider">VS</div>

          <div className="player-slot">
            <div className={`player-card ${opponent?.is_ready ? 'ready' : ''}`}>
              <div className="player-avatar">{opponent ? '👤' : '⏳'}</div>
              <h3>{opponent?.nickname || '等待玩家加入...'}</h3>
              {opponent && (
                <span className="status-badge">
                  {opponent.is_ready ? '已准备' : '未准备'}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="room-actions">
          {opponent ? (
            <button
              className={`btn btn-large ${myPlayer?.is_ready ? 'btn-warning' : 'btn-success'}`}
              onClick={handleToggleReady}
            >
              {myPlayer?.is_ready ? '取消准备' : '准备'}
            </button>
          ) : (
            <p className="waiting-text">等待对手加入房间...</p>
          )}

          {allReady && (
            <p className="starting-text">游戏即将开始...</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default RoomLobby;
